var React = require('react');

function RemovePhotoIconInline (overrides) {
const props = Object.assign({}, {"viewBox":"0 0 64 64","fill":"none"}, overrides);
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32","cy":"32.5","r":"32","fill":"#ffede8","key":0}),React.createElement("path",{"d":"M41 39.5v-14c0-1.1-.9-2-2-2H25c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM28.5 34l2.5 3.01 3.5-4.51 4.5 6H25l3.5-4.5z","fill":"#c13e06","key":1})]);
}

module.exports = RemovePhotoIconInline;

RemovePhotoIconInline.default = RemovePhotoIconInline;
